<template>
  <Modal :id="'cmp-quickmodal'" @cancelled="onCancelClick">
    <template slot="header">{{ $t(title) }}</template>
    <template slot="body">
      <div
        ref="qm-form"
        v-if="fields.length == 0 && forms.length == 0"
        class="form-group"
      >
        <TextField
          class="m1"
          :id="placeholder"
          v-bind="textAreaConfig"
          v-model="dataValue"
          isModel
          :placeholder="placeholder"
          @keyup="onKeyup"
        />
      </div>
      <DynamicForm
        ref="qm-form"
        v-if="forms.length > 0"
        :forms="forms"
        :formsData="dataObj"
        :textFieldConfig="textFieldConfig"
        @changed="onDynamicFormChange"
        @validated="onDynamicFOrmValidation"
      />
      <div ref="qm-form" v-if="fields.length > 0" class="form-group">
        <TextField
          v-for="field of fields"
          :key="field.key"
          class="m1"
          :id="placeholder"
          v-bind="textAreaConfig"
          v-model="dataObj[field.key]"
          isModel
          :required="field.required"
          :placeholder="field.placeholder"
          @keyup="onKeyup"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">Cancel</button>
      <button
        class="dt-button v1 s6"
        :class="{
          disabled: !isFormValid()
        }"
        :disabled="!isFormValid()"
        @click="onOKClick"
      >
        OK
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import DynamicForm from "@plugins/form-builder/dynamic-form";
import { EventHooks } from "../text-field";

export default {
  components: {
    Modal,
    DynamicForm
  },
  props: {
    title: {
      type: String
    },
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    fields: {
      type: Array,
      default: () => []
    },

    // Form Input Mode only works with Form Props
    forms: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => {}
    },
    textFieldConfig: {
      type: Object,
      default: () => ({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        immediateValidation: true,

        validationEvent: EventHooks.OnKeyup,
        valueChangedEvent: EventHooks.OnBlur
      })
    }
  },
  mounted: function() {
    let qmForm = this.$refs["qm-form"];
    if (this.forms && this.forms.length > 0) {
      qmForm = qmForm.$el;
    }

    setTimeout(() => {
      qmForm?.querySelector("input")?.focus();
    }, 1);
  },
  watch: {
    value: {
      immediate: true,
      handler: function(to, from) {
        if (to) {
          this.dataValue = to;
        }
      }
    },
    fields: {
      immediate: true,
      handler: function(to, from) {
        if (to) {
          this.dataObj = to.reduce((accm, cur) => {
            accm[cur.key] = cur.value;
            return accm;
          }, {});
        }
      }
    },
    formData: {
      immediate: true,
      handler: function(to, from) {
        if (to) {
          this.dataObj = to;
        }
      }
    }
  },
  data: function() {
    return {
      textAreaConfig: {
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      dataValue: "",
      dataObj: {},
      formValidation: {}
    };
  },
  computed: {
    isMultiForm: function() {
      return (
        (this.fields && this.fields.length > 0) ||
        (this.forms && this.forms.length > 0)
      );
    }
  },
  methods: {
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onOKClick: function() {
      if (this.isMultiForm) {
        this.$emit("ok", this.dataObj);
      } else {
        this.$emit("ok", this.dataValue);
      }
    },
    onKeyup: function(event) {
      // console.log(event);

      if (["Enter", "NumpadEnter"].includes(event.code)) {
        this.onOKClick();
      }
    },
    onDynamicFormChange: function({ name, value }) {
      this.dataObj = {
        ...this.dataObj,
        [name]: value
      };
    },
    onDynamicFOrmValidation: function({ name, value }) {
      this.formValidation = {
        ...this.formValidation,
        [name]: value
      };
    },
    isFormValid: function() {
      return Object.keys(this.formValidation)
        .map(key => this.formValidation[key].valid)
        .every(e => e);
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss" scoped></style>
